
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

import divSpan from '@/components/DivSpan';

export default {
name: "dynamic-form-list",
directives: {
TransferDom
},
components: {
Checker,
CheckerItem,
Popup,
divSpan
},
data() {
return {
token: '',
configCode: '',
wrapperHeight: 0,
contentList: [],
placeholder: '',
searchData: '',
allLoaded: false,
showRight: false,
quickShow: false,
checkedValue: '线索来源',
middleSearchCriteria: [],
quicklySearch: [],
topSearch: {},
eventConfig: {},
dynamicFormCode: '',
componentConfig: {},
dynamicFormConfig: {},
pageRules: {
direction: '' || 'DESC', // 排序
fromClientType: 'pc',
number: 0, // 当前页
property: '' || 'createdDate', // 排序字段
rules: [],
size: 15, //当前页数据多少条
specialConditions: [],
workflowSearchBean: '',
dynamicFormCode: '',
ignoreField: true,
},
url: '',
diyUrl: false,
cardConfig: [],
totalPages: 0,
id: '',
hiddenQuickly:false,
hiddenMidSearch:false,
tabList:[],
tabField:'',
searchObj:{}
}
},
created() {
let winParm = new this.getQueryString();
if (winParm['configCode']) {
this.configCode = winParm['configCode'];
}
if (winParm['dynamicFormCode']) {
this.dynamicFormCode = winParm['dynamicFormCode'];
} else {
this.dynamicFormCode = this.$route.params['dynamicFormCode'];
}
if (this.dynamicFormCode || this.configCode) {
const code = this.dynamicFormCode || this.configCode;
this.$get(`api/component-config/name/${code}`).then((data) => {
this.componentConfig = data;
this.dynamicFormConfig = JSON.parse(this.componentConfig.configData);
this.pageRules.dynamicFormCode = this.dynamicFormCode;
this.pageRules.property = this.dynamicFormConfig.property;
this.pageRules.fixedRule = this.dynamicFormConfig['fixedRule'];
this.pageRules.workflowSearchBean = this.dynamicFormConfig['workflowSearchBean'] || undefined;
this.url = this.dynamicFormConfig['url'] || ('api/dynamic-form-value/' + this.dynamicFormCode);
this.diyUrl = this.dynamicFormConfig['diyUrl'];
this.pageRules.ignoreField = this.dynamicFormConfig['ignoreField'];
this.pageRules = JSON.parse(JSON.stringify(this.pageRules));
if (!this.diyUrl) {
this.url = this.url + '/page';
}
this.getListData();
this.getMiddleSearchCriteria();
})
}
},
methods: {
getListData(e) {
this.$loadingShow();
this.$post(this.url, this.pageRules).then(info => {
this.totalPages = info['totalPages'];
if (e == 'top') {
this.contentList = JSON.parse(JSON.stringify(info['content']));
this.$refs.loadmore.onTopLoaded();
} else if (e == 'bottom') {
this.contentList = this.contentList.concat(info.content);
this.contentList = JSON.parse(JSON.stringify(this.contentList));
this.$refs.loadmore.onBottomLoaded();
} else {
this.contentList = JSON.parse(JSON.stringify(info['content']));
}
this.$loadingHide();
}).catch(() => {
this.$loadingHide();
});
},
getMiddleSearchCriteria() {
if (this.dynamicFormConfig['appConfig']) {
if(this.dynamicFormConfig['appConfig'].hiddenQuickly){
this.hiddenQuickly = true;
if(this.dynamicFormConfig['appConfig'].tabObj){
if(this.dynamicFormConfig['appConfig'].tabObj.hidden){
this.hiddenMidSearch = this.dynamicFormConfig['appConfig'].tabObj.hidden;
}
if(this.dynamicFormConfig['appConfig'].tabObj.dictionary){
this.$get(`api/dict-tables/search-with-list?dictCode=${this.dynamicFormConfig['appConfig'].tabObj.dictionary}`).then((res) => {
let list = [{name:'全部',code:''}];
res.dictItems.forEach((dictItem) => {
list.push({code:dictItem.code,name:dictItem.value})
});
this.tabList = list;
})
}else{
if(this.dynamicFormConfig['appConfig'].tabObj.tabList){
this.tabList = this.dynamicFormConfig['appConfig'].tabObj.tabList;
}
}
this.tabField = this.dynamicFormConfig['appConfig'].tabObj.field;
}
}
if(this.dynamicFormConfig['appConfig']['middleSearchCriteria']){
this.middleSearchCriteria = this.dynamicFormConfig['appConfig']['middleSearchCriteria'];
}
if(this.dynamicFormConfig['appConfig']['quicklySearch']){
this.quicklySearch = this.dynamicFormConfig['appConfig']['quicklySearch'];
}
if(this.dynamicFormConfig['appConfig']['cardConfig']){
this.cardConfig = this.dynamicFormConfig['appConfig']['cardConfig'];
}
if(this.dynamicFormConfig['appConfig']['topSearch']){
this.topSearch = this.dynamicFormConfig['appConfig']['topSearch'];
}
if(this.dynamicFormConfig['appConfig']['eventConfig']){
this.eventConfig = this.dynamicFormConfig['appConfig']['eventConfig'];
}
for (let i = 0; i < this.middleSearchCriteria.length; i++) {
if (this.middleSearchCriteria[i]['dictionary']) {
const dictionary = this.middleSearchCriteria[i]['dictionary'];
this.$get(`api/dict-tables/search-with-list`, {dictCode: dictionary}).then(info => {
info.dictItems.forEach(item => {
const obj = {
name: item.value,
code: item.code
};
this.middleSearchCriteria[i].value.push(obj);
});
})
}
}
} else {
this.$vux.toast.text('未查找到列表配置');
}

},
onItemClick(e) {
this.pageRules.rules = this.pageRules.rules.filter(info => info['field'] != this.tabField);
if (e) {
this.searchObj = {
collectIndex: -1,
field: this.tabField,
option: "IN",
values: [e]
};
this.pageRules.rules.push(JSON.parse(JSON.stringify(this.searchObj)));
}
this.getListData();
},
init: function () {

if (this.$store.state.device === 'wap') {
this.wrapperHeight =
document.documentElement.clientHeight -
this.$refs.wrapper.getBoundingClientRect().top;
} else {
this.wrapperHeight =
document.documentElement.clientHeight -
this.$refs.wrapper.getBoundingClientRect().top;
}
},
searchInput() {
console.log(this.searchData);
},
clear() {
this.searchData = '';
},
quickSearch(e) {
if (e == 2) {
this.showRight = true;
this.quickShow = false;
}
if (e == 1) {
this.quickShow = !this.quickShow;
this.showRight = false;
}
},
quicklyClick(info) {
this.pageRules.specialConditions = [];
if (info.condition) {
this.pageRules.specialConditions.push(info.condition);
}
this.getListData();
},
cancel() {
this.middleSearchCriteria.forEach(item => {
item['checkedValue'] = '';
this.pageRules.rules = this.pageRules.rules.filter(info => info['field'] == item['searchName']);
});
this.getListData();
this.showRight = false;
},
confirm() {
this.pageRules.rules = [];
this.middleSearchCriteria.forEach(item => {
if (item['checkedValue']) {
const obj = {
field: item['searchName'],
option: item['option'],
values: [item['checkedValue']],
collectIndex: item['collectIndex'] || -1
};
this.pageRules.rules.push(JSON.parse(JSON.stringify(obj)));
}
});
this.getListData();
this.showRight = false;
},
searchConfirm() {
this.pageRules.rules = this.pageRules.rules.filter(info => info['field'] != this.topSearch['searchName']);
if (this.searchData) {
const obj = {
field: this.topSearch['searchName'],
option: this.topSearch['option'],
values: [this.searchData],
collectIndex: this.topSearch['collectIndex'] || -1
};
this.pageRules.rules.push(JSON.parse(JSON.stringify(obj)));
}
this.getListData();
},
loadTop() {
this.pageRules.number = 0;
this.getListData('top');
},
loadBottom() {
if (this.totalPages <= this.pageRules.number + 1) {
this.$vux.toast.text('已获取全部');
this.$refs.loadmore.onBottomLoaded();
return;
}
this.pageRules.number++;
this.getListData('bottom');
},
openFlow(e) {
let paramList = [];
if(this.eventConfig.parameter){
paramList = this.eventConfig.parameter.split('.');
}
let obj = e;
paramList.forEach((par) => {
obj = obj[par];
});
const requestId = obj;
let baseUrl;
if(this.$store.state.systemConfig){
baseUrl = this.$store.state.systemConfig.systemUrl + '#/';
}else{
return;
}
this.$store.dispatch('commitChangeIframeUrl',`${baseUrl}jy-sso?token=${this.token}&requestId=${requestId}&isMobile=1`);
this.$router.push('dynamic-flow');
},

getQueryString() {
let name, value;
let str = location.href;  
let num = str.indexOf('?');
str = str.substr(num + 1); 

let arr = str.split('&'); 
for (let i = 0; i < arr.length; i++) {
num = arr[i].indexOf('=');
if (num > 0) {
name = arr[i].substring(0, num);
value = arr[i].substr(num + 1);
this[name] = value;
}
}
},
conversionName(data, name) {
let retanData = '';
if (name) {
let colName = name.split('.');
if (data.hasOwnProperty(colName[0])) {
if (colName.length > 1) {
for (let i = 0; i < colName.length; i++) {
if (i == 0) {
retanData = data[colName[0]];
} else {
if (retanData != null) {
retanData = retanData[colName[i]];
} else {
return retanData = '';
}
}
}
return retanData == null ? '' : retanData;
} else {
return data[colName[0]] == null ? '' : data[colName[0]];
}
} else {
return retanData == null ? '' : retanData;
}
} else {
return retanData == null ? '' : retanData;
}
},
goBack(){
this.$router.go(-1);
}
},
mounted() {
let tokens = localStorage.getItem('_token');
if(tokens){
this.token = tokens.substr(7);
}
setTimeout(() => {
this.init();
},600);
}
}



// WEBPACK FOOTER //
// ./src/page/dynamic-form-list/dynamic-form-list.vue